import { ca } from '@cian/analytics';

export function trackParkSlideChange(label: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'click_to_slide',
    label,
    useLastProducts: true,
  });
}
